import { PersonFields } from './PersonFields';

export default PersonFields;
